import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { useDropzone } from "react-dropzone";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { updateMeta } from "../../store/actions/metaAction";

const WorksCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const [title, setTitle] = useState("");
	const [type, setType] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [typeEn, setTypeEn] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [pictureMeta, setPictureMeta] = useState("");

	const [video, setVideo] = useState(null);
	const dispatch = useDispatch();

	let editor = null;

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		setLoading(false);
		dispatch(
			updateMeta({
				title: "اضافة عمل جديد",
				breadcrumb: "الأعمال",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	// const handlePicture = () => {
	// 	const fileInput = document.querySelector("#picture");
	// 	setPicture(URL.createObjectURL(fileInput.files[0]));
	// };

	// const handleVideo = () => {
	// 	const fileInput = document.querySelector("#video");
	// 	setVideo(URL.createObjectURL(fileInput.files[0]));
	// };
	const [mediaPreview, setMediaPreview] = useState(null);
	const [mediaType, setMediaType] = useState(null); // "image" or "video"

	const handleMediaUpload = e => {
		const file = e.target.files[0];
		if (file) {
			const fileURL = URL.createObjectURL(file);
			if (file.type.startsWith("image/")) {
				setMediaType("image");
				setMediaPreview(fileURL);
			} else if (file.type.startsWith("video/")) {
				setMediaType("video");
				setMediaPreview(fileURL);
			} else {
				// لو مش صورة أو فيديو
				setMediaType(null);
				setMediaPreview(null);
				alert("الملف يجب أن يكون صورة أو فيديو فقط");
			}
		}
	};

	const handleSubmit = e => {
		e.preventDefault();

		if (!title || !titleEn) {
			return toast.error("جميع البيانات مطلوبة");
		}

		const mediaInput = document.querySelector("#media");
		const file = mediaInput.files[0];

		if (file) {
			setLoading(true);
			const formData = new FormData();
			formData.append("file", file);

			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					const mediaName = response.data.data.name;

					const postData = {
						title: {
							ar: title,
							en: titleEn,
						},
						image: mediaName, // يمكنك استخدام "media" بدلاً من "image" حسب الباك اند
						imageMeta: pictureMeta,
					};

					axios
						.post(
							`${process.env.REACT_APP_API_URL}/posts`,
							{
								category_id: 19,
								admin_id: auth.id,
								data: postData,
							},
							{
								headers: {
									Authorization: `Bearer ${cookie.get("token")}`,
									Accept: "application/json",
								},
							}
						)
						.then(() => {
							history.push("/works/index");
							toast.success("تم اضافة العمل بنجاح!");
							setLoading(false);
						})
						.catch(() => {
							toast.error("خطأ، برجاء المحاولة مره اخرى!");
							setLoading(false);
						});
				})
				.catch(() => {
					toast.error("خطأ في رفع الملف، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		} else {
			toast.error("برجاء اختيار صورة أو فيديو أولاً!");
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="row">
									<div className="col-md-12">
										<div className="form-item">
											<label htmlFor="title">العنوان</label>
											<input
												type="text"
												id="title"
												required
												onChange={e => setTitle(e.target.value)}
											/>
										</div>
									</div>
									{/* <div className="col-md-12">
										<div className="form-item">
											<label htmlFor="url">نوع العمل</label>
											<input
												type="text"
												id="url"
												onChange={e => setType(e.target.value)}
											/>
										</div>
									</div> */}
									<div className="col-md-12">
										<div className="form-item">
											<label htmlFor="title">العنوان بالانجليزيه</label>
											<input
												type="text"
												dir="ltr"
												id="title"
												required
												onChange={e => setTitleEn(e.target.value)}
											/>
										</div>
									</div>
									{/* <div className="col-md-12">
										<div className="form-item">
											<label htmlFor="url">نوع العمل بالانجليزيه </label>
											<input
												type="text"
												id="url" dir="ltr"
												onChange={e => setTypeEn(e.target.value)}
											/>
										</div>
									</div> */}
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="media">الصورة / الفيديو</label>

									{/* وصف الصورة */}
									<div className="form-item">
										<input
											type="text"
											id="pictureMeta"
											onChange={e => setPictureMeta(e.target.value)}
											value={pictureMeta}
											placeholder="ادخل وصف الصوره"
										/>
									</div>

									{/* رفع صورة أو فيديو */}
									<input
										type="file"
										accept="image/*,video/*"
										onChange={handleMediaUpload}
										id="media"
									/>

									{/* عرض المعاينة */}
									{mediaPreview && mediaType === "image" && (
										<div className="img-holder">
											<img
												src={mediaPreview}
												alt="preview"
												className="imagePreview"
											/>
										</div>
									)}

									{mediaPreview && mediaType === "video" && (
										<div className="img-holder">
											<video
												src={mediaPreview}
												controls
												width="100%"
												height="100%"
												className=""
											/>
										</div>
									)}
								</div>
							</div>
						</div>

						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default WorksCreate;
